<div
  class="notifications-panel"
  data-testid="notifications-panel"
  role="dialog"
  aria-label="Notifications"
>
  <header class="panel-header">Notifications</header>
  @if (!loading && notifications.length) {
    <div class="panel-body">
      @for (n of notifications; track trackById($index, n)) {
        <div
          class="notification-item"
          data-testid="notification-item"
          [class.is-read]="(n.notification_status || '').toUpperCase() === 'READ'"
          [class.is-unread]="isUnread(n)"
          [attr.data-status]="(n.notification_status || '').toLowerCase()"
          (click)="onNotificationClick(n, $event)"
        >
          <div
            class="bullet"
            [class.bullet--read]="(n.notification_status || '').toUpperCase() === 'READ'"
          ></div>
          <div class="notification-content">
            <div class="text-block">
              <div class="title-row">
                <h4 class="title">{{ n.message }}</h4>
              </div>
              <div class="meta">
                <span class="subtitle">{{ n.notification_type_description }}</span>
                <span class="dot" aria-hidden="true">•</span>
                <span class="time">{{ n.time }}</span>
              </div>
            </div>
            @if (isStatusChangeRequestNotification(n)) {
              <div class="actions">
                <button
                  type="button"
                  class="action-btn action-btn--primary"
                  data-testid="notification-review-btn"
                  (click)="onReviewStatusChange(n); $event.stopPropagation()"
                >
                  Review
                </button>
              </div>
            }
            @if (
              isFileRequestNotification(n) ||
              isDdqUnderReviewNotification(n) ||
              isLoaFileRequestNotification(n) ||
              isSignatoryListNotification(n) ||
              isSigningProcessCompleteNotification(n)
            ) {
              <div class="actions">
                <button
                  type="button"
                  class="action-btn action-btn--primary"
                  data-testid="notification-download-btn"
                  (click)="onDownloadDocument(n, $event)"
                  aria-label="Download document"
                >
                  Download
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="panel-body empty">
      @if (loading) {
        Loading...
      } @else {
        No notifications
      }
    </div>
  }
</div>
